<template>
	<div class="pricing-page">
		<page-title :name="pageName" :title="pageTitle" :breadcrumbs="pageBreadcrumbs" />
		<page-content :content="pageContent" />

		<section-title component-class="margin-top-100">
			<h2 v-html="$t('Sentence.PricingPageTitle')"></h2>
			<!-- <p>{{ $t('Sentence.PricingPageText') }}</p> -->
		</section-title>

		<div class="margin-bottom-120 margin-top-100">
			<div class="container">
				<div class="billboards">
					<div class="container">
						<div class="row">
							<div class="col-md-offset-4 col-md-4 col-sm-6 col-xs-12 mg-top-70">
								<div class="billboard-outer text-center">
									<plan-box :type="planFree"></plan-box>

									<router-link :to="{ name: 'registerUser' }" class="billboard-link">
										{{ $t('Link.SignUp') }}
									</router-link>
								</div>
							</div>
							<!-- <div class="col-md-4 col-sm-6 col-xs-12">
								<div class="billboard-outer text-center">
									<plan-box :type="planPremium"></plan-box>

									<router-link :to="{ name: 'registerUser' }" class="billboard-link">
										{{ $t('Link.SignUp') }}
									</router-link>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Helpers from '@/mixins/Helpers'
import IconInfo from '@/mixins/IconInfo'
import PageContent from '@/components/partials/PageContent'
import PageInfo from '@/mixins/PageInfo'
import PageTitle from '@/components/partials/PageTitle'
import PlanBox from '@/components/partials/PlanBox'
import SectionTitle from '@/components/partials/SectionTitle'

export default {
	name: 'Pricing',
	components: {
		PageContent,
		PageTitle,
		PlanBox,
		SectionTitle,
	},
	mixins: [IconInfo, Helpers, PageInfo],
	data() {
		return {
			pageToNotIndexFromRobots: true,
		}
	},
}
</script>



// WEBPACK FOOTER //
// src/views/service/Pricing.vue